/**
 * Registro del service worker del proyecto.
 *
 * Aunque actualmente el SW principal está orientado a Firebase Messaging,
 * este registro también habilita capacidades PWA como instalación y soporte
 * offline según evolucione la estrategia de cache.
 */

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.\d+){3}$/)
);

/**
 * Registra el service worker personalizado (firebase-messaging-sw.js)
 * cuando estamos en producción o localhost y el navegador lo soporta.
 */
export function register(config) {
  // Si quieres que también funcione en desarrollo local,
  // puedes quitar la verificación de NODE_ENV === "production"
  // o adaptarla a tus necesidades.
  if ("serviceWorker" in navigator) {
    // Verifica que la URL del servicio sea la misma que la de la app
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener("load", () => {
      // Aquí ponemos la ruta a tu service worker.
      // Debe coincidir con el nombre y ubicación en /public
      const swUrl = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;

      if (isLocalhost) {
        // En localhost, verificamos si el SW es válido.
        checkValidServiceWorker(swUrl, config);
      } else {
        // En producción (o no localhost) simplemente registramos.
        registerValidSW(swUrl, config);
      }
    });
  }
}

/**
 * Registra el service worker y maneja sus eventos.
 */
function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log("Service Worker registrado con éxito en:", swUrl);

      // Este evento se dispara si se encuentra una nueva versión
      // del service worker o se actualiza.
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            // Si ya existe un service worker controlando la página,
            // significa que la app se ha actualizado.
            if (navigator.serviceWorker.controller) {
              console.log("Nueva versión del Service Worker disponible.");
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Primer registro, el contenido está cacheado.
              console.log("Contenido cacheado para uso offline.");
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error al registrar el Service Worker:", error);
    });
}

/**
 * Verifica si el service worker en localhost es válido.
 * Si la ruta no existe o no es JavaScript, recarga para evitar 404.
 */
function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      // Si no se encuentra el archivo en localhost o no es JS:
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // Desregistra y recarga la página para descargar la versión actual
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Si todo va bien, registra el SW
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "No se encontró conexión a internet. La app se está ejecutando en modo offline."
      );
    });
}

/**
 * Desregistra el service worker, útil para pruebas.
 */
export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
